<template>
    <div class="row">
        <div class="col-12">
            <SpeqUsers />
        </div>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

import SpeqUsers from "@/components/speq/users/SpeqUsers.vue";

export default {
    props: [],
    emits: [],
    components: {
        SpeqUsers,
    },
    setup() {
        const store = useStore();

        let isSpeq = computed(function () {
            return store.state.isSpeq;
        });

        onMounted(() => {});

        return {
            isSpeq,
        };
    },
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {},
};
</script>
